import React, { useContext } from 'react';

import { MenuSyncState } from './types';

const noopPromise = async () => undefined;

export const MenuSyncContext = React.createContext<{
  syncStatus: MenuSyncState | undefined;
  isLoadingSyncStatus: boolean;
  refetchSyncInfo: () => Promise<any>;
}>({
  syncStatus: undefined,
  isLoadingSyncStatus: false,
  refetchSyncInfo: noopPromise,
});

export const useMenuSyncContext = () => {
  const { syncStatus, isLoadingSyncStatus, refetchSyncInfo } = useContext(MenuSyncContext);

  return { syncStatus, isLoadingSyncStatus, refetchSyncInfo };
};
